module.exports = __webpack_public_path__ + "static/media/sync.57d835bf.svg";